import {
  IResultHistoryPrivyDAO,
  IResultPrivyFileDAO,
} from '../Modules/PrivyIDStatement/DAO/privy.dao';
import instance from '../Services/interceptor';

export const getHistoryPrivyAPI = async (): Promise<
  IResultHistoryPrivyDAO[]
> => {
  const { data } = await instance.get(
    `/Candidate/file/upload/history?uploadHistoryType=PrivyAgreement`,
  );
  return data;
};

export const getFileListAPI = async (): Promise<IResultPrivyFileDAO[]> => {
  const { data } = await instance.get(
    `/DocumentManagement/GetContentInquiry?repositorySymbolicName=privy&contentProperties=pdf`,
  );
  return data;
};

export const downloadFileAPI = async (params: any) => {
  const { id } = params;
  const { data } = await instance.get(
    `/DocumentManagement/GetContent?contentId=${id}`,
  );
  const byteCharacters = atob(data.content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const conversionResult = new Blob([byteArray], {
    type: data.properties.contenttype,
  });

  const url = window.URL.createObjectURL(conversionResult);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', data.originalFileName);
  link.click();
  window.URL.revokeObjectURL(url);
};
